const state = {
    auth_status:1,
    refuse_type:0,
    auth_cate:0,
}
const getters = {
    auth_status: state => state.auth_status,
    refuse_type: state => state.refuse_type,
    auth_cate: state => state.auth_cate,
}
const mutations = {
    currentAuthStatus(state, update) {
        state.auth_status = update
    },
    currentRefuseType(state, update) {
        state.refuse_type = update
    },
    currentAuthCate(state, update) {
        state.auth_cate = update
    },
  };
const actions = {
    setAuthStatus({commit}, auth_status) {
        commit('currentAuthStatus',auth_status)
    },
    setRefuseType({commit}, refuse_type) {
        commit('currentRefuseType',refuse_type)
    },
    setAuthCate({commit}, auth_cate) {
        commit('currentAuthCate',auth_cate)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
